<template>
  <div>
    <div id="tools">
      <button @click="changeTool('brush')">描く</button> &nbsp;
      <button @click="changeTool('eraser')">消しゴム</button> &nbsp;
      <button @click="clearCanvas()">クリア</button> &nbsp;
      <!-- <input type="number" min="1" max="10" value="1" v-model="lineWidth" /> -->
    </div>
    <canvas
      id="canvas"
      ref="canvas"
      @mousedown="startDrawing"
      @mouseup="endDrawing"
      @mousemove="draw"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "scratchpad",
  props: {
    currentPage: Number,
  },
  data: function () {
    return {
      lineWidth: 6,
      drawing: false,
      ctx: null,
    };
  },
  mounted: function () {
    const canvas = this.$refs.canvas;
    this.ctx = canvas.getContext("2d");
    canvas.addEventListener("touchstart", this.startDrawing);
    canvas.addEventListener("touchmove", this.drawTouch);
    canvas.addEventListener("touchend", this.endDrawing);

    canvas.height = 800;
    canvas.width = 600;
  },
  methods: {
    clearCanvas: function () {
      this.ctx.clearRect(0, 0, 600, 600);
    },
    changeTool: function (tool) {
      switch (tool) {
        case "brush":
          {
            this.ctx.globalCompositeOperation = "source-over";
            this.ctx.strokeStyle = "#000000";
            this.lineWidth = 6
          }
          break;
        case "eraser":
          {
            this.ctx.globalCompositeOperation = "destination-out";
            this.lineWidth = 7
          }
          break;
        default:
          this.ctx.strokeStyle = "#000000";
          break;
      }
    },
    startDrawing: function (e) {
      this.layerForBrowser(e);
      this.drawing = true;
      this.draw(e);
    },
    endDrawing: function () {
      this.drawing = false;
      this.ctx.beginPath();
    },
    draw: function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.drawing) return;
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.lineCap = "round";

      const { layerX, layerY } = this.layerForBrowser(e.layerX, e.layerY);
      this.ctx.lineTo(layerX, layerY);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(layerX, layerY);
    },
    drawTouch: function (e) {
      this.drawing = true;
      const touch = e.touches[0];
      const rect = e.target.getBoundingClientRect();
      const coords = {
        x: touch.pageX - rect.left,
        y: touch.pageY - rect.top,
      };
      e.preventDefault();
      e.stopPropagation();
      if (!this.drawing) return;
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.lineCap = "round";

      this.ctx.lineTo(coords.x, coords.y);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(coords.x, coords.y);
    },
    layerForBrowser: function (layerX, layerY) {
      let userAgent = navigator.userAgent;
      if (userAgent.indexOf("Trident") != -1) {
        layerY -= 110;
        layerX -= 470;
      }

      if (
        userAgent.indexOf("Firefox") > -1 &&
        userAgent.indexOf("Trident") == -1
      ) {
        layerY -= 50;
      }

      return {
        layerX,
        layerY,
      };
    },
  },
};
</script>

<style scoped>
#canvas {
  /* border: 2px solid black; */
  height: 800px;
  width: 600px;
}

#tools {
  padding: 1rem 0;
  background: white;
}
</style>
